module.exports = __webpack_public_path__ + "static/media/head.ef63664f.svg";